import { TRegisterParams } from 'types/services';
import { getRecaptchaToken } from 'services/production/utils/getRecaptchaToken';
import { GOOGLE_RECAPTCHA_KEY } from 'utils/constants';
import { m8API } from 'services/production/m8';
import { normalizeClientProfileInfo } from 'services/production/utils/normalizeClientProfileInfo';
import { normalizeM8AccountInfo } from 'services/production/utils/normalizeM8AccountInfo';

export const register = async (params: TRegisterParams) => {
  const { clientInfo } = params;

  const recaptchaToken = await getRecaptchaToken(GOOGLE_RECAPTCHA_KEY);

  const accountInfo = await m8API.auth.register({
    userProfile: normalizeClientProfileInfo({
      ...clientInfo,
      resident: clientInfo.resident === 'true',
    }).toM8UserProfile(),
    email: clientInfo.email,
    sex: clientInfo.sex,
    recaptchaToken,
  });

  return normalizeM8AccountInfo(accountInfo).toUserAccountInfo();
};
